import { IconButton, Grid } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Controller } from "react-hook-form";
import { diagnosisTypeName } from "dto/encounter.dto";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import PostCoordinationDiagnosisAutoComplete from "components/postCoordinationDiagnosisAutoComplete";
import { useEncounter } from "pages/encounter/encounter.provider";
import { v4 as uuidv4 } from "uuid";
import StarPurple500SharpIcon from "@mui/icons-material/StarPurple500Sharp";
import StarOutlineSharpIcon from "@mui/icons-material/StarOutlineSharp";
import { useFavorite } from "pages/encounter/favorite.provider";
import { isEmpty } from "lodash";
export interface DiagnosisSectionProps {
    name: diagnosisTypeName;
    nestedIndex: number;
    swap: (from: number, to: number) => void;
    onRemove: () => void;
}

const DiagnosisSection = (props: DiagnosisSectionProps) => {
    const { name, nestedIndex, swap, onRemove } = props;

    const { encounterForm, recorder } = useEncounter();
    const { handleFavorite, isFavorited } = useFavorite();

    return (
        <Grid item container spacing={1}>
            <Grid item xs={10}>
                <Controller
                    control={encounterForm.control}
                    name={`${name}.${nestedIndex}` as const}
                    render={({ field }) => {
                        return (
                            <PostCoordinationDiagnosisAutoComplete
                                externalCause={
                                    name === "diagnosis.externalCause"
                                }
                                setState={(value) => {
                                    field.onChange({
                                        ...field.value,
                                        id: uuidv4(),
                                        term: value?.keyword,
                                        icd10: value?.icd,
                                        conceptId: value?.conceptId,
                                        recorder: recorder.license,
                                        recorderName: recorder.name,
                                        stack: value.stack
                                    });
                                }}
                                defaultValue={field.value.term}
                                stack={field.value.stack}
                                autoFocus={name === "diagnosis.principal"}
                                disabledFreeText={
                                    name === "diagnosis.principal"
                                }
                                recentData={encounterForm.watch().diagnosis}
                            />
                        );
                    }}
                />
            </Grid>
            <Grid item xs={2} display={"flex"}>
                <IconButton
                    tabIndex={-1}
                    onClick={() => {
                        swap(nestedIndex, nestedIndex - 1);
                    }}
                    sx={{ padding: 0 }}
                    size="small"
                    color="success"
                    disabled={
                        nestedIndex === 0 && name === "diagnosis.principal"
                    }
                >
                    <ArrowUpwardIcon fontSize="inherit" />
                </IconButton>
                <IconButton
                    tabIndex={-1}
                    onClick={() => {
                        swap(nestedIndex, nestedIndex + 1);
                    }}
                    sx={{ padding: 0 }}
                    size="small"
                    color="warning"
                >
                    <ArrowDownwardIcon fontSize="inherit" />
                </IconButton>

                <Controller
                    control={encounterForm.control}
                    name={`${name}.${nestedIndex}` as const}
                    render={({ field }) => {
                        return (
                            <IconButton
                                disabled={
                                    isEmpty(field.value?.term) &&
                                    isEmpty(field.value?.icd10)
                                }
                                tabIndex={-1}
                                color="primary"
                                size="large"
                                sx={{ padding: 0, paddingLeft: 1 }}
                                onClick={() => handleFavorite(field.value)}
                            >
                                {isFavorited(field.value) && (
                                    <StarPurple500SharpIcon />
                                )}
                                {!isFavorited(field.value) && (
                                    <StarOutlineSharpIcon />
                                )}
                            </IconButton>
                        );
                    }}
                />

                <IconButton
                    tabIndex={-1}
                    color="error"
                    size="large"
                    onClick={onRemove}
                    sx={{ padding: 0 }}
                >
                    <DeleteIcon />
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default DiagnosisSection;
